import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useToastNotificationContext } from '../../hooks/global/alert/useToastNotification';
import { registerErrorModalCallback } from '../../services/errorModalService';

const ErrorFramework = () => {
  const { createErrorToast } = useToastNotificationContext();
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();

  //allows to call error toast notification on axiosInstance for a consistent error on failed requests
  useEffect(() => {
    const newCreateErrorToast = (code: number) => {
      const prevPage = location.pathname;
      createErrorToast(
        intl.formatMessage({
          defaultMessage: 'Sorry something went wrong, click here to report',
        }),
        () => {
          navigate(
            `customer/contact/customer-ticket?code=${code}&prev=${prevPage}`,
          );
        },
      );
    };

    registerErrorModalCallback(newCreateErrorToast);

    return () => {};
  }, [createErrorToast, navigate, location, intl]);

  return (
    <>
      <Outlet />
    </>
  );
};

export default ErrorFramework;
